import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class StateService {
    private commentObj: BehaviorSubject<any> = new BehaviorSubject(null);

    emitCommentObject(data: any) {
        this.commentObj.next(data);
    }

    getNaObject(): Observable<any> {
        return this.commentObj.asObservable();
    }

}
